// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__37jyk","box":"WorkspacesBox_box__3DMB2","node":"WorkspacesBox_node__37b62"};